import { CUSTOM_MODEL_VOICES, ELEVENLABS_VOICES } from "./constants.js";

export const buildAudiobookVoiceMap = () => {
    const voiceMap = {};

    ELEVENLABS_VOICES.forEach((voice) => {
        voiceMap[voice.id] = `${voice.name} (${voice.gender})${voice.special ? "(Special)" : ""}`;
    });

    CUSTOM_MODEL_VOICES.forEach((voice) => {
        voiceMap[`custom:${voice.id}`] = `${voice.name} (${voice.gender})(Custom)`;
    });

    return voiceMap;
};

export const parseAudiobookVoiceSelection = (voiceSelection, availableVoices) => {
    const isCustomVoice = voiceSelection.startsWith("custom:");
    const voiceId = isCustomVoice ? voiceSelection.split(":")[1] : voiceSelection;

    return {
        voiceId,
        voiceProvider: isCustomVoice ? "custom" : "elevenlabs",
        voiceName: availableVoices[voiceSelection].split(" ")[0],
    };
};
